var parent = require('../actual/is-iterable');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/is-iterable.js
// module id = 617
// module chunks = 0 1